import React, { useState } from "react";
import { Box, Button } from "@showitinc/showit-wc";
import ElementLinkModal from "../../../components/multiselect/ElementLinkModal";
import UIActions from "../../../actions/UIActions";
import AppConstants from "../../../constants/AppConstants";
import PropertyPanelSectionWrapper from "../../base/PropertyPanelSectionWrapper";

const { PANEL_SECTION_ELEMENT_ACTIONS } = AppConstants;

/**
 * @component ElementPropertiesClickActionsPanel
 * @description A React component that renders a panel for configuring click actions on selected elements.
 * It provides a button to launch a modal for setting up element links.
 *
 * @param {Object} props - The component props
 * @param {Array} props.title - optional title override for the panel (defaults to "Click Actions")
 * @param {Array} props.selectedElements - An array of currently selected elements
 * @param {Object} props.viewState - The view state object
 *
 */
const ElementPropertiesClickActionsPanel = ({
  block,
  selectedElements,
  title = "Click Actions",
  viewState,
}) => {
  const [showClickActionsModal, setShowClickActionsModal] = useState(false);
  const [clickActionsModalActive, setClickActionsModalActive] = useState(false);

  const _launchClickActionsModal = () => {
    setShowClickActionsModal(true);
    setClickActionsModalActive(true);
  };

  const _hideElementLinkModal = () => {
    setClickActionsModalActive(false);
  };

  const _exitElementLinkModal = () => {
    setShowClickActionsModal(false);
    setClickActionsModalActive(false);
  };

  const _togglePanelSection = (sectionName) => {
    UIActions.toggleElementsPropertiesSection({ name: sectionName });
  };

  const activeSection = viewState.get("activeSection");

  return (
    <PropertyPanelSectionWrapper
      title={title}
      key="multi-element-actions"
      helpTooltip="click-actions"
      open={activeSection === PANEL_SECTION_ELEMENT_ACTIONS}
      onSIPanelToggle={() => _togglePanelSection(PANEL_SECTION_ELEMENT_ACTIONS)}
    >
      <Box my="3" px="3">
        <Button fullWidth variant="outline" onClick={_launchClickActionsModal}>
          Configure Link
        </Button>
      </Box>

      {clickActionsModalActive ? (
        <ElementLinkModal
          block={block}
          selectedElements={selectedElements}
          show={showClickActionsModal}
          onHide={_hideElementLinkModal}
          onExited={_exitElementLinkModal}
        />
      ) : null}
    </PropertyPanelSectionWrapper>
  );
};

export default ElementPropertiesClickActionsPanel;
